import { FC } from 'react'
import styled from '@emotion/styled'
import { ModalCard } from 'src/v2/views/owner-reveal/insights/parcels/parcel-modal/modal-card'
import { OwnerItem } from 'src/v2/components/owner-item'
import * as atoms from 'src/v2/state/owner-reveal/entity-parcels'
import { useAtomValue } from 'jotai'
import { getEntityLink } from 'src/v2/utils/entity'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
`

export const AssociatedOwnersCard: FC = () => {
  const parcel = useAtomValue(atoms.selectedParcel)

  return (
    <ModalCard title="Associated Owners">
      <Content>
        {parcel?.owners.map((owner) => <OwnerItem id={owner.id} name={owner.name} link={getEntityLink(owner.id)} />)}
      </Content>
    </ModalCard>
  )
}
